var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app flex-row align-items-center" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c(
                    "b-card-group",
                    [
                      _c(
                        "b-card",
                        { staticClass: "p-4", attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c("validation-observer", {
                                attrs: { tag: "form" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ passes }) {
                                      return [
                                        _c(
                                          "b-form",
                                          {
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                                return passes(
                                                  _vm.changePassword
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("h1", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.password_force_change"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c(
                                              "p",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.password_force_change_desc"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-validated-input-group-form-input",
                                              {
                                                attrs: {
                                                  id: "username",
                                                  label:
                                                    _vm.$t("message.username"),
                                                  "input-group-size": "mb-3",
                                                  rules: "required",
                                                  icon: "icon-user",
                                                  type: "text",
                                                  autocomplete:
                                                    "username email",
                                                },
                                                model: {
                                                  value: _vm.input.username,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.input,
                                                      "username",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "input.username",
                                                },
                                              }
                                            ),
                                            _c(
                                              "b-validated-input-group-form-input",
                                              {
                                                attrs: {
                                                  id: "current-password",
                                                  label: _vm.$t(
                                                    "message.password_current"
                                                  ),
                                                  "input-group-size": "mb-3",
                                                  rules: "required",
                                                  icon: "icon-lock",
                                                  type: "password",
                                                  autocomplete:
                                                    "current-password",
                                                },
                                                model: {
                                                  value: _vm.input.password,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.input,
                                                      "password",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "input.password",
                                                },
                                              }
                                            ),
                                            _c(
                                              "b-validated-input-group-form-input",
                                              {
                                                attrs: {
                                                  id: "new-password",
                                                  label: _vm.$t(
                                                    "message.password_new"
                                                  ),
                                                  "input-group-size": "mb-3",
                                                  rules: "required",
                                                  icon: "icon-lock",
                                                  type: "password",
                                                  autocomplete: "off",
                                                },
                                                model: {
                                                  value: _vm.input.newPassword,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.input,
                                                      "newPassword",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "input.newPassword",
                                                },
                                              }
                                            ),
                                            _c(
                                              "b-validated-input-group-form-input",
                                              {
                                                attrs: {
                                                  id: "confirm-password",
                                                  label: _vm.$t(
                                                    "message.password_confirm"
                                                  ),
                                                  "input-group-size": "mb-3",
                                                  rules:
                                                    "required|confirmed:new-password",
                                                  icon: "icon-lock",
                                                  type: "password",
                                                  autocomplete: "off",
                                                },
                                                model: {
                                                  value:
                                                    _vm.input.confirmPassword,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.input,
                                                      "confirmPassword",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "input.confirmPassword",
                                                },
                                              }
                                            ),
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass: "px-4",
                                                        attrs: {
                                                          block: "",
                                                          variant: "primary",
                                                          type: "submit",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.password_change"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-card",
                        {
                          staticClass:
                            "text-white bg-grey-900 py-5 d-md-down-none",
                          staticStyle: { width: "44%" },
                          attrs: { "no-body": "" },
                        },
                        [
                          _c("b-card-body", { staticClass: "text-center" }, [
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/brand/dt-logo-vertical-white-text.svg"),
                                  width: "100%",
                                },
                              }),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("InformationalModal", { attrs: { message: _vm.passwordChangeError } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }